import BaseApi from '@/api/Base/BaseApi'
import {
  CreateEnhancedPipelineGroupPayload,
  CreateModelPipelinePayload,
  CreateModelPipelineResponse,
  DeleteGroupNodePayload,
  GetGroupCheckpointsPayload,
  GetGroupCheckpointsResponse,
  GetModelsAndCheckpointsPayload,
  GetModelsAndCheckpointsResponse,
  UpdateGroupCheckpointsPayload,
  UpdateGroupCheckpointsResponse
} from '@/api/ModelPipeline/types'

const ROOT = '/project'

export default class ModelPipelineApi extends BaseApi {
  deleteGroupNode(payload: DeleteGroupNodePayload) {
    const { projectId, groupNodeId } = payload
    return this.agent.delete<any>(`${ROOT}/${projectId}/model-pipeline/${groupNodeId}`)
  }

  getModelsAndCheckpoints(payload: GetModelsAndCheckpointsPayload) {
    const { projectId, inferenceNodeId } = payload
    return this.agent.get<GetModelsAndCheckpointsResponse>(`${ROOT}/${projectId}/model-pipeline/${inferenceNodeId}/checkpoints`)
  }

  createModelPipeline(payload: CreateModelPipelinePayload) {
    const { projectId, inferenceNodeId, modelCheckpoints, nodeCreatedTime } = payload
    return this.agent.post<CreateModelPipelineResponse>(
      `${ROOT}/${projectId}/model-pipeline/create/${inferenceNodeId}`,
      { modelCheckpoints, nodeCreatedTime }
    )
  }

  getGroupCheckpoints(payload: GetGroupCheckpointsPayload) {
    const { projectId, groupNodeId } = payload
    return this.agent.get<GetGroupCheckpointsResponse>(`${ROOT}/${projectId}/model-pipeline/${groupNodeId}/group-checkpoints`)
  }

  updateGroupCheckpoints(payload: UpdateGroupCheckpointsPayload) {
    const { projectId, groupNodeId, instanceCheckpoints } = payload
    return this.agent.put<UpdateGroupCheckpointsResponse>(
      `${ROOT}/${projectId}/model-pipeline/${groupNodeId}/group-checkpoints`,
      { instanceCheckpoints }
    )
  }

  createEnhancedPipelineGroup(payload: CreateEnhancedPipelineGroupPayload) {
    const { projectId, position, nodeCreatedTime } = payload
    return this.agent.post<any>(`${ROOT}/${projectId}/model-pipeline/create-group`, { position, nodeCreatedTime })
  }
}
